import * as React from "react"
import { Pane } from 'evergreen-ui';


class Prefooter extends React.Component  {
	

render(){
return (
	<Pane className="relative overflow-visible bg-02464e after:absolute after:bottom-0 after:z-0 after:h-1/2 after:w-full after:mainback">
		<Pane className="max-w-[75rem] relative z-10 m-auto px-8">
			<Pane className="size-full overflow-hidden rounded-xl p-6 sm:p-12 md:p-10 lg:p-16 bg-white relative">
				<Pane className="flex flex-col gap-16 lg:flex-row">
					<Pane className="flex-[2]">
						<h2 className="max-w-[16ch] text-4xl md:text-5xl lg:text-[37px] pb-2 font-medium cl-083136">
							Automate your customer engagement
						</h2>
						<ul className="flex flex-col flex-nowrap gap-2 opacity-85 md:flex-row mt-4 text-xs font-semibold text-muted">
							<li className="flex items-center gap-2 text-nowrap"><svg data-sanity-icon="check-circle-broken" width="1em" height="1em"
									viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path
										d="M22 11.0857V12.0057C21.9988 14.1621 21.3005 16.2604 20.0093 17.9875C18.7182 19.7147 16.9033 20.9782 14.8354 21.5896C12.7674 22.201 10.5573 22.1276 8.53447 21.3803C6.51168 20.633 4.78465 19.2518 3.61096 17.4428C2.43727 15.6338 1.87979 13.4938 2.02168 11.342C2.16356 9.19029 2.99721 7.14205 4.39828 5.5028C5.79935 3.86354 7.69279 2.72111 9.79619 2.24587C11.8996 1.77063 14.1003 1.98806 16.07 2.86572M22 4L12 14.01L9 11.01"
										stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"></path>
								</svg>14-day free trial</li>
							<li className="flex items-center gap-2 text-nowrap"><svg data-sanity-icon="check-circle-broken" width="1em" height="1em"
									viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path
										d="M22 11.0857V12.0057C21.9988 14.1621 21.3005 16.2604 20.0093 17.9875C18.7182 19.7147 16.9033 20.9782 14.8354 21.5896C12.7674 22.201 10.5573 22.1276 8.53447 21.3803C6.51168 20.633 4.78465 19.2518 3.61096 17.4428C2.43727 15.6338 1.87979 13.4938 2.02168 11.342C2.16356 9.19029 2.99721 7.14205 4.39828 5.5028C5.79935 3.86354 7.69279 2.72111 9.79619 2.24587C11.8996 1.77063 14.1003 1.98806 16.07 2.86572M22 4L12 14.01L9 11.01"
										stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"></path>
								</svg>No credit card required</li>
							<li className="flex items-center gap-2 text-nowrap"><svg data-sanity-icon="check-circle-broken" width="1em" height="1em"
									viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path
										d="M22 11.0857V12.0057C21.9988 14.1621 21.3005 16.2604 20.0093 17.9875C18.7182 19.7147 16.9033 20.9782 14.8354 21.5896C12.7674 22.201 10.5573 22.1276 8.53447 21.3803C6.51168 20.633 4.78465 19.2518 3.61096 17.4428C2.43727 15.6338 1.87979 13.4938 2.02168 11.342C2.16356 9.19029 2.99721 7.14205 4.39828 5.5028C5.79935 3.86354 7.69279 2.72111 9.79619 2.24587C11.8996 1.77063 14.1003 1.98806 16.07 2.86572M22 4L12 14.01L9 11.01"
										stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"></path>
								</svg>Instant setup</li>
						</ul>
					</Pane>
					
					<Pane className="flex flex-col md:flex-row items-center justify-start gap-2 lg:flex-row lg:justify-center">
						<a href="/pricing" className="dsndbtn dsndbtn-accent dsndbtn-outline w-full md:w-fit w-2/4 tx-white rounded-full font-medium lg:bigcta md:bigcta cl-083136">See pricing</a>
						<a href="https://app.dynosend.com/account/register" target="_blank" rel="noreferrer" className="dsndbtn w-full dsndbtn-main bg-primary md:w-fit w-2/4 font-medium tx-white rounded-full lg:bigcta md:bigcta">Start trial</a>
					</Pane>
				</Pane>
			</Pane>
		</Pane>
	</Pane> 
  );
}}





export default Prefooter;